import React, { useRef, useEffect, useState } from 'react';

export const Component = () => {
  const containerRef = useRef(null);
  const [revealedWordCount, setRevealedWordCount] = useState(0);

  // Story content
  const storySegments = [
    "Nesolearn helps institutions and learners turn education into verified opportunity. Issue tamper-proof credentials in minutes, then connect every learner's journey directly to the jobs, programs, and employers built to recognize it."
  ];

  const allWords = storySegments.flatMap(segment => segment.split(' '));
  const totalWords = allWords.length;

  useEffect(() => {
    let rafId = null;
    let targetProgress = 0;
    let currentProgress = 0;

    const smoothScroll = () => {
      const difference = targetProgress - currentProgress;
      currentProgress += difference * 0.12;

      if (Math.abs(targetProgress - currentProgress) > 0.001) {
        const wordsToReveal = Math.floor(currentProgress * totalWords);
        setRevealedWordCount(wordsToReveal);
        rafId = requestAnimationFrame(smoothScroll);
      } else {
        setRevealedWordCount(Math.floor(targetProgress * totalWords));
      }
    };

    const handleScroll = () => {
      if (!containerRef.current) return;

      const container = containerRef.current;
      const rect = container.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const eyeLevel = windowHeight * 0.62;

      const animationStart = rect.top + window.scrollY - eyeLevel;
      const animationEnd = rect.top + window.scrollY + rect.height - eyeLevel;
      const scrollDistance = animationEnd - animationStart;
      const currentScroll = window.scrollY;

      let progress = (currentScroll - animationStart) / scrollDistance;
      targetProgress = Math.max(0, Math.min(1, progress));

      if (rafId) {
        cancelAnimationFrame(rafId);
      }

      rafId = requestAnimationFrame(smoothScroll);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
    };
  }, [totalWords]);

  let wordIndex = 0;

  return (
    <div className="bg-white">
      {/* Content */}
      <div
        ref={containerRef}
        className="max-w-5xl mx-auto px-4 md:px-8 py-16 min-h-0 md:min-h-[60vh]"
      >
        <div className="space-y-16">
          {storySegments.map((segment, segmentIndex) => {
            const segmentWords = segment.split(' ');
            const segmentStartIndex = wordIndex;
            wordIndex += segmentWords.length;

            return (
              <p
                key={segmentIndex}
                className="text-xl md:text-2xl lg:text-3xl leading-tight tracking-tight font-sans font-bold"
              >
                {segmentWords.map((word, i) => {
                  const currentWordIndex = segmentStartIndex + i;
                  const isRevealed = currentWordIndex < revealedWordCount;
                  return (
                    <span
                      key={i}
                      className={isRevealed ? 'text-black' : 'text-gray-300'}
                      style={{
                        transition: 'all 0.3s ease-out',
                        opacity: isRevealed ? 1 : 0.4
                      }}
                    >
                      {word}{' '}
                    </span>
                  );
                })}
              </p>
            );
          })}
        </div>
      </div>

    </div>
  );
};

export default Component;